import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const productsAPI = createApi({
  reducerPath: "productsAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllProducts: builder.query({
      query: ({ page, filter, categoryId, searchTerm, selectedVariantValues }) => {
        let queryParams = `user/products/list-all-products?page=${page}`;
        if (filter) {
          queryParams += `&filter=${filter}`;
        }
        if (categoryId) {
          queryParams += `&category_id=${categoryId}`;
        }
        if (searchTerm) {
          queryParams += `&q=${searchTerm}`;
        }
        if (selectedVariantValues) {
          queryParams += `&variant_value_ids=${selectedVariantValues}`;
        }
        return queryParams;
      },
    }),
    getAllCategories: builder.query({
      query: () => `user/categories/list-all-category`,
    }),
    getBrandById: builder.query({
      query: (id) => `brands/show/${id}`,
    }),
    getRelatedProducts: builder.query({
      query: (categoryId) => `user/products/get-related-products/${categoryId}`,
    }),
    getVariants: builder.query({
      query: () => `variants`,
    }),

  }),
});

export const { useGetAllProductsQuery, useGetAllCategoriesQuery, useGetBrandByIdQuery, useGetRelatedProductsQuery, useGetVariantsQuery } = productsAPI;
